module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921124151_T.16f57210.jpg";